import { useEffect, useState } from "react";
import { Button, Card, Typography, Divider, Form, InputNumber, Select, Flex, Checkbox } from "antd";
import { LeftOutlined, MinusOutlined, PlusOutlined } from "@ant-design/icons";
import { useNavigate, useParams } from "react-router-dom";
import * as Validation from "../../../utils/helper/validation";
import { changeLoader } from "../../../redux/reducers/loader";
import { useDispatch } from "react-redux";
import globalRequest from "../../../utils/global/globalRequest";
import * as Apis from "../../../utils/helper/enum";
import toast from "react-hot-toast";
import { selectTime } from "../../../utils/helper/constants";

const daysName = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

const EditHours = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  let { id } = useParams();

  const initialTimeSlot = {
    openTime: null,
    closeTime: null,
    capacity: null,
    discount: null,
    openTimeErr: null,
    closeTimeErr: null,
    capacityErr: null,
    discountErr: null,
  };
  const [timeSlots, setTimeSlots] = useState({
    1: [initialTimeSlot], // Sunday
    2: [initialTimeSlot], // Monday
    3: [initialTimeSlot], // Tuesday
    4: [initialTimeSlot], // Wednesday
    5: [initialTimeSlot], // Thursday
    6: [initialTimeSlot], // Friday
    7: [initialTimeSlot], // Saturday
  });

  const [edit, setEdit] = useState(false);

  const handleAddSlot = (day) => {
    const newSlots = { ...timeSlots };
    newSlots[day].push({ ...initialTimeSlot });
    setTimeSlots(newSlots);
  };

  const handleRemoveSlot = (day, index) => {
    const newSlots = { ...timeSlots };
    if (newSlots[day].length > 1) {
      newSlots[day].splice(index, 1);
      setTimeSlots(newSlots);
    }
  };

  const handleTimeChange = (day, index, field, value) => {
    if (field === "isChecked") {
      const updatedSlots = timeSlots[day].map((slot, slotIndex) => {
        if (slotIndex === index) {
          return { ...slot, [field]: value };
        }
        return slot;
      });
      setTimeSlots({
        ...timeSlots,
        [day]: updatedSlots,
      });
    } else {
      const updatedSlots = timeSlots[day].map((slot, slotIndex) => {
        if (slotIndex === index) {
          return { ...slot, [field]: value, [`${field}Err`]: null };
        }
        return slot;
      });
      setTimeSlots({
        ...timeSlots,
        [day]: updatedSlots,
      });
    }
  };

  const validateSlots = () => {
    let hasError = false;
    const newSlots = { ...timeSlots };

    // Object.keys(newSlots).forEach((day) => {
    //   newSlots[day].forEach((slot, index) => {
    //     if (!slot.openTime) {
    //       newSlots[day][index].openTimeErr = "Open time is required.";
    //       hasError = true;
    //     }
    //     if (!slot.closeTime) {
    //       newSlots[day][index].closeTimeErr = "Close time is required.";
    //       hasError = true;
    //     }
    //     if (!slot.capacity) {
    //       newSlots[day][index].capacityErr = "Capacity is required.";
    //       hasError = true;
    //     }
    //     if (slot.capacity && slot.capacity < 1) {
    //       newSlots[day][index].capacityErr = "Invalid capacity.";
    //       hasError = true;
    //     }

    //     // Validate that closeTime is greater than openTime
    //     if (slot.openTime && slot.closeTime && slot.closeTime <= slot.openTime) {
    //       newSlots[day][index].closeTimeErr = "Close time must be greater than open time.";
    //       hasError = true;
    //     }

    //   });
    // });

    // Function to check if two time slots overlap
    const isOverlapping = (slot1, slot2) => {
      return slot1.openTime < slot2.closeTime && slot2.openTime < slot1.closeTime;
    };

    Object.keys(newSlots).forEach((day) => {
      const daySlots = newSlots[day];

      // Validate each slot
      daySlots.forEach((slot, index) => {
        if (!slot.openTime) {
          newSlots[day][index].openTimeErr = "Open time is required.";
          hasError = true;
        }
        if (!slot.closeTime) {
          newSlots[day][index].closeTimeErr = "Close time is required.";
          hasError = true;
        }
        if (!slot.capacity) {
          newSlots[day][index].capacityErr = "Capacity is required.";
          hasError = true;
        }
        if (slot.capacity && slot.capacity < 1) {
          newSlots[day][index].capacityErr = "Invalid capacity.";
          hasError = true;
        }
        if (slot.discount && slot.discount > 100) {
          newSlots[day][index].discountErr = "Discount cannot exceed 100";
          hasError = true;
        }
        // Validate that closeTime is greater than openTime
        if (slot.openTime && slot.closeTime && slot.closeTime <= slot.openTime) {
          newSlots[day][index].closeTimeErr = "Close time must be greater than open time.";
          hasError = true;
        }

        // Validate that closeTime is greater than openTime
        // Validate that closeTime is greater than openTime
        if (slot.capacity === undefined || slot.capacity === null || slot.capacity === "") {
          newSlots[day][index].capacityErr = "Capacity is required.";
          hasError = true;
        } else if (!Number.isInteger(Number(slot.capacity))) {
          newSlots[day][index].capacityErr = "Only integer values are allowed.";
          hasError = true;
        } else if (slot.capacity < 0) {
          newSlots[day][index].capacityErr = "Invalid capacity.";
          hasError = true;
        } else if (slot.capacity.toString().length > 9) {
          newSlots[day][index].capacityErr = "Capacity should not exceed 8 digits.";
          hasError = true;
        }
      });

      // Check for overlapping slots for the same day
      for (let i = 0; i < daySlots.length; i++) {
        for (let j = i + 1; j < daySlots.length; j++) {
          if (isOverlapping(daySlots[i], daySlots[j])) {
            newSlots[day][i].openTimeErr = "Time slots must not overlap.";
            newSlots[day][j].openTimeErr = "Time slots must not overlap.";
            hasError = true;
          }
        }
      }
    });

    setTimeSlots(newSlots);
    return !hasError;
  };

  const handleSubmit = async () => {
    if (!validateSlots()) return;

    // Proceed with form submission
    let time_slots = [];
    for (let i in timeSlots) {
      if (timeSlots[i].length > 0) {
        let slots = [];
        for (let j in timeSlots[i]) {
          slots.push({
            openTime: timeSlots[i][j].openTime,
            closeTime: timeSlots[i][j].closeTime,
            capacity: timeSlots[i][j].capacity,
            discount: timeSlots[i][j].discount ? timeSlots[i][j].discount : 0,
          });
        }
        time_slots.push({
          day: daysName[i - 1].toLowerCase(),
          slots: slots,
        });
      }
    }

    let insertArray = {
      zone_id: id,
      time_slots: time_slots,
    };
    dispatch(changeLoader(true));
    try {
      let url = Apis?.MANAGE_ZONE?.CREATE_TIME_SLOTE;
      let method = "post";
      if (edit) {
        url = Apis?.MANAGE_ZONE?.EDIT_TIME_SLOTE;
        method = "put";
      }
      let response = await globalRequest(url, method, insertArray, {}, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let msg = "Working hours added successfully";
        if (id) msg = "Working hours updated successfully";
        toast.success(msg, {
          duration: 2000,
        });
        navigate("/zone/timeslots-holidays/" + id);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
    dispatch(changeLoader(false));
  };

  const getTimeSlotes = async (id) => {
    let params = {
      id: id,
      type: "day",
    };
    try {
      let response = await globalRequest(Apis.MANAGE_ZONE.GET_ALL_TIME_SLOTE, "get", {}, { params: params }, true);
      let apiResponse = response?.data;
      if (response?.status === 200) {
        if (!apiResponse?.data) setEdit(false);
        else {
          setEdit(true);
          let data = apiResponse?.data?.data;

          let sunday = [];
          let monday = [];
          let tuesday = [];
          let wednesday = [];
          let thursday = [];
          let friday = [];
          let saturday = [];
          for (let i in data) {
            if (data[i].day === "sunday")
              sunday.push({
                openTime: data[i].openTime,
                closeTime: data[i].closeTime,
                capacity: data[i].capacity,
                discount: data[i].discount ? data[i].discount : 0,
                openTimeErr: null,
                closeTimeErr: null,
                capacityErr: null,
                discountErr: null,
              });
            if (data[i].day === "monday")
              monday.push({
                openTime: data[i].openTime,
                closeTime: data[i].closeTime,
                capacity: data[i].capacity,
                discount: data[i].discount ? data[i].discount : 0,
                openTimeErr: null,
                closeTimeErr: null,
                capacityErr: null,
                discountErr: null,
              });
            if (data[i].day === "tuesday")
              tuesday.push({
                openTime: data[i].openTime,
                closeTime: data[i].closeTime,
                capacity: data[i].capacity,
                discount: data[i].discount ? data[i].discount : 0,
                openTimeErr: null,
                closeTimeErr: null,
                capacityErr: null,
                discountErr: null,
              });
            if (data[i].day === "wednesday")
              wednesday.push({
                openTime: data[i].openTime,
                closeTime: data[i].closeTime,
                capacity: data[i].capacity,
                discount: data[i].discount ? data[i].discount : 0,
                openTimeErr: null,
                closeTimeErr: null,
                capacityErr: null,
                discountErr: null,
              });
            if (data[i].day === "thursday")
              thursday.push({
                openTime: data[i].openTime,
                closeTime: data[i].closeTime,
                capacity: data[i].capacity,
                discount: data[i].discount ? data[i].discount : 0,
                openTimeErr: null,
                closeTimeErr: null,
                capacityErr: null,
                discountErr: null,
              });
            if (data[i].day === "friday")
              friday.push({
                openTime: data[i].openTime,
                closeTime: data[i].closeTime,
                capacity: data[i].capacity,
                discount: data[i].discount ? data[i].discount : 0,
                openTimeErr: null,
                closeTimeErr: null,
                capacityErr: null,
                discountErr: null,
              });
            if (data[i].day === "saturday")
              saturday.push({
                openTime: data[i].openTime,
                closeTime: data[i].closeTime,
                capacity: data[i].capacity,
                discount: data[i].discount ? data[i].discount : 0,
                openTimeErr: null,
                closeTimeErr: null,
                capacityErr: null,
                discountErr: null,
              });
          }

          setTimeSlots({
            1: [...sunday], // Sunday
            2: [...monday], // Monday
            3: [...tuesday], // Tuesday
            4: [...wednesday], // Wednesday
            5: [...thursday], // Thursday
            6: [...friday], // Friday
            7: [...saturday], // Saturday
          });
        }
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };
  useEffect(() => {
    getTimeSlotes(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Card>
        <div className="">
          <Typography className="text-xl font-semibold" align={"left"}>
            <LeftOutlined className="mr-2" onClick={() => navigate(-1)} />
            Time Slots
          </Typography>
        </div>
        <Divider />
        <div className="min-h-[calc(100vh_-_305px)]">
          <Form
            layout="vertical"
            initialValues={{
              remember: true,
            }}
            autoComplete="off"
          >
            {/* <Checkbox.Group className="w-full"> */}
            {Object.keys(timeSlots).map((day) => (
              <>
                <Flex key={day} gap="middle" className="w-full ">
                  <div className="flex items-start flex-wrap sm:flex-nowrap gap-4 w-full">
                    <Checkbox
                      checked={timeSlots[day]?.length}
                      className="min-w-[200px]"
                      onChange={(e) => {
                        // handleTimeChange(day, index, "isChecked", e)
                        if (timeSlots[day]?.length) {
                          setTimeSlots((prev) => ({
                            ...prev,
                            [day]: [],
                          }));
                        } else {
                          setTimeSlots((prev) => ({
                            ...prev,
                            [day]: [initialTimeSlot],
                          }));
                        }
                      }}
                    >
                      {daysName[day - 1]}
                    </Checkbox>
                    <div className="flex flex-col gap-4 w-full">
                      {timeSlots[day]?.map((slot, index) => (
                        <div key={index} className="flex gap-4 flex-wrap sm:flex-nowrap">
                          {/* {index === 0 ? (
                            <div className="w-full">
                              <Checkbox
                                checked={slot.isChecked}
                                onChange={(e) =>
                                  handleTimeChange(day, index, "isChecked", e)
                                }
                              >
                                {daysName[day - 1]}
                              </Checkbox>
                            </div>
                          ) : (
                            <div className="w-full"></div>
                          )} */}
                          <div className="w-full">
                            <Select
                              size="large"
                              placeholder="Select"
                              options={selectTime}
                              showSearch
                              filterOption={(input, selectTime) => (selectTime?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                              onChange={(value) => {
                                handleTimeChange(day, index, "openTime", value);
                                // timeSlots[day][index].openTimeErr = '';
                              }}
                              value={slot.openTime}
                              className="sm:max-w-full max-w-[200px] w-full "
                            />
                            {slot.openTimeErr && <span className="text-red-100">{slot.openTimeErr}</span>}
                          </div>
                          <div className="w-full">
                            <Select
                              size="large"
                              placeholder="Select"
                              options={selectTime}
                              showSearch
                              filterOption={(input, selectTime) => (selectTime?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                              onChange={(value) => handleTimeChange(day, index, "closeTime", value)}
                              value={slot.closeTime}
                              className="sm:max-w-full max-w-[200px] w-full "
                            />
                            {slot.closeTimeErr && <span className="text-red-100">{slot.closeTimeErr}</span>}
                          </div>
                          <div className="w-full">
                            <InputNumber
                              type="text"
                              size="large"
                              maxLength={8}
                              placeholder="Capacity"
                              className="sm:max-w-full max-w-[200px] w-full "
                              onChange={(value) => {
                                let val = Validation.strFormat(value, "number");
                                handleTimeChange(day, index, "capacity", val);
                              }}
                              value={slot.capacity}
                            />
                            {slot.capacityErr && <span className="text-red-100">{slot.capacityErr}</span>}
                          </div>
                          <div className="w-full">
                            <InputNumber
                              type="text"
                              size="large"
                              maxLength={3}
                              placeholder="Discount %"
                              className="sm:max-w-full max-w-[200px] w-full "
                              onChange={(value) => {
                                let val = Validation.strFormat(value, "number");
                                handleTimeChange(day, index, "discount", val);
                              }}
                              value={slot.discount}
                            />
                            {slot.discountErr && <span className="text-red-100">{slot.discountErr}</span>}
                          </div>
                          {/* Add/edit driver add a new parameter for total trip distance */}
                          {/* <div className="w-full">
                            <InputNumber
                              type="text"
                              size="large"
                              placeholder="Total Trip Distance"
                              className="sm:max-w-full max-w-[200px] w-full "
                              addonAfter="Km"
                            />
                          </div> */}
                          {index === timeSlots[day]?.length - 1 ? (
                            <div className="w-full">
                              <Button icon={<PlusOutlined />} onClick={() => handleAddSlot(day)} />
                            </div>
                          ) : (
                            <div className="w-full">
                              <Button icon={<MinusOutlined />} onClick={() => handleRemoveSlot(day, index)} danger />
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </Flex>
                <Divider className="mt-5" />
              </>
            ))}
            {/* </Checkbox.Group> */}
          </Form>
        </div>
        <Divider />
        <div className="flex justify-end gap-3">
          <Button onClick={() => navigate("/zone/timeslots-holidays/" + id)}>Cancel</Button>
          <Button type="primary" htmlType="submit" onClick={() => handleSubmit()}>
            Save
          </Button>
        </div>
      </Card>
    </>
  );
};
export default EditHours;
